import React from 'react';
import { TableStyle } from './style';

export default function TableMonth({ children }) {
  return (
    <TableStyle>
      <thead>
        <tr>
          <th>Obrigações Acessórias Mensais</th>
          <th className="text">JAN</th>
          <th className="text">FEV</th>
          <th className="text">MAR</th>
          <th className="text">ABR</th>
          <th className="text">MAI</th>
          <th className="text">JUN</th>
          <th className="text">JUL</th>
          <th className="text">AGO</th>
          <th className="text">SET</th>
          <th className="text">OUT</th>
          <th className="text">NOV</th>
          <th className="text">DEZ</th>
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </TableStyle>
  );
}
